var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "col-sm-4" }, [
    _c("div", { staticClass: "contact-box bordered p-4" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "dept-title" }, [
          _c("span", [_vm._v(" " + _vm._s(_vm.contact.deptName))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("ul", { staticClass: "contact-social-icons" }, [
          _c("li", [
            _c(
              "span",
              {
                staticClass: "pointer",
                on: {
                  click: function ($event) {
                    return _vm.$emit("displayContactForm", _vm.contact)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-envelope" }), _vm._v(" Contact")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }